import {
  Svg,
  Circle,
  CircleGroup,
  Pos,
  Lab,
  Text1,
  LabContainer,
  InnerLabelOuter,
} from "../OverviewLabel/Overview.label.style";

import { useLocation } from "react-router-dom";
import { useBreak } from "hooks/useBreak";

export const InnerMobileLabel = ({
  scale,
  c,
  r,
  sc = 1,
  d,
  l,
  labelsInfo,
  heading,
  clr,
}) => {
  const isMobile = useBreak("md_dn");
  const here = useLocation().pathname.split("/");

  const isIsometry = here[here.length - 2] === "isometry";

  /* ===============================
     SCALE LOGIC (CONSISTENT)
  =============================== */
  const s = 0.6 / sc === Infinity ? 10 : 0.6 / sc;
  const dl = {
    d,
    l,
    s,
    notHovered: true, // always collapsed look
  };

  /* ===============================
     CIRCLE POSITION
  =============================== */
  const cx = r?.[0];
  const cy = r?.[1];

  /* ===============================
     GUARDS
  =============================== */
  if (!isIsometry || !isMobile || !c || !r) return null;

  return (
    <Pos
      c={c}
      style={{
        position: "absolute",
        transform: "scale(3.4)", // same as before
        pointerEvents: "none",   // 🔑 disables interaction
      }}
    >
      {/* ===============================
         SVG CIRCLES
      =============================== */}
      <Svg viewBox="0 0 100 100">
        <CircleGroup transform={`translate(${cx} ${cy})`}>
          <Circle cx={0} cy={0} r={15} clr={clr} />
          <Circle cx={0} cy={0} r={25} fillOpacity="0.5" clr={clr} />
          <Circle cx={0} cy={0} r={35} fillOpacity="0.3" clr={clr} />
        </CircleGroup>
      </Svg>

      {/* ===============================
         LABEL (STATIC)
      =============================== */}
      <InnerLabelOuter scale={scale} {...dl}>
        <LabContainer {...dl} clr={clr}>
          <Lab clr={clr}>
            <Text1 className="h3" s={s} clr={clr}>
              {heading}
            </Text1>
          </Lab>
        </LabContainer>
      </InnerLabelOuter>
    </Pos>
  );
};
